import AboutSec2 from "../../../About/AboutSec2/AboutSec2";
import HomeAboutSec from "../../../Home/HomeAboutSec";
import HomeCtaBanner from "../../../Home/HomeCtaBanner/HomeCtaBanner";
import IndustriesSec2 from "../../IndustiresSec2/IndustriesSec2";
import IndustriesSec1 from "../../IndustiresSec1/IndustriesSec1";
import SEO from "../../../../components/SEO";

export default function FinancialAdvisoryServices({ currentLanguage = "en" }) {
  // SEO titles based on language
  const pageTitles = {
    en: "Financial Advisory Services",
    fr: "Conseil financier", // ✅ correct French
  };

  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <>
      <SEO title={pageTitle} />
      <HomeAboutSec currentLanguage={currentLanguage} />
      <AboutSec2 currentLanguage={currentLanguage} />
      <IndustriesSec1 currentLanguage={currentLanguage} />
      <IndustriesSec2 currentLanguage={currentLanguage} />
      <HomeCtaBanner currentLanguage={currentLanguage} />
    </>
  );
}
